export default __webpack_public_path__ + "static/media/about-sheds.2ae00d86.jpg";